export class HowChooseColor {
    title: string;
    description: string;
    id: string;
}

export const HowChooseColorSet: HowChooseColor[] = [
    {
        title: "BRYŁA",
        description: "Kolor elewacji wpływa na postrzeganie bryły budynku. Ciemne kolory przyciągają ją bardziej do ziemi, natomiast jasne wysmuklają. Na dom parterowy, z wysokim spadzistym dachem, lepiej wybrać jasne barwy.",
        id: 'bryla'
    },
    {
        title: "HARMONIA",
        description: "Bardzo dobrze jeśli dom wtapia się w otoczenie. Wówczas należy wziąć pod uwagę kolorystykę okolicznych budynków albo warunków przyrody.",
        id: "harmonia"
    },
    {
        title: "KONTRAST",
        description: "Dom może też kontrastować z otoczeniem i wyróżniać się na jego tle. W tym przypadku trzeba się wykazać dużym wyczuciem i wrażliwością na kolory",
        id: "kontrast"
    },
    {
        title: "ELEWACJA",
        description: "Kolor elewacji powinien współgrać z kolorem dachu, stolarki okiennej i drzwiowej, bramy garażowej a nawet ogrodzenia",
        id: "elewacja"
    },
    {
        title: "INTENSYWNE KOLORY",
        description: "W przypadku łączenia wielu kolorów na elewacji, intensywne barwy należy stosować raczej na mniejszych fragmentach. Nie należy wprowadzać zbyt wielu kolorów.",
        id: "kolory"
    },
    {
        title: "ŚWIATŁO",
        description: "Światło ma ogromny wpływ na postrzeganie kolorów. Ten sam kolor inaczej będzie prezentował się na elewacji południowej, doświetlonej przez większość dnia, a inaczej na zwykle zacienionej elewacji północnej.",
        id: "swiatlo"
    },
];